import { createIcon } from "@chakra-ui/icons";

// Created from layers.svg

export const VectorMapIcon = createIcon({
  displayName: "Vector",
  viewBox: "0 0 18 18",
  path: (
    <g>
      <path
        d="M5.43163 0.799805L5.43163 16.7998M12.5895 0.799805L12.5895 16.7998M0.800049 5.01033H16.8M0.800049 12.1682H16.8"
        stroke="#69A0C9"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </g>
  ),
});
